import React, { useEffect, useState, useCallback } from 'react';
import { Edit, Delete, Add, ArrowBack, Search } from "@mui/icons-material";
import api from '../../services/api';
import styles from '../../assets/styles/LayoutShared.module.css';
import ColoniaForm from './ColoniaForm';

const ColoniasList = () => {
  const [colonias, setColonias] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [coloniaEditando, setColoniaEditando] = useState<any>(null);

  const fetchColonias = useCallback((searchTerm: string) => {
    api.get(`/pesca/colonias?search=${searchTerm}`).then(res => setColonias(res.data.data));
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => setSearch(tempSearch), 500);
    return () => clearTimeout(handler);
  }, [tempSearch]);

  useEffect(() => {
    fetchColonias(search);
  }, [search, fetchColonias]);

  const handleNovo = () => {
    setColoniaEditando(null);
    setFormOpen(true);
  };

  const handleEditar = (colonia: any) => {
    setColoniaEditando(colonia);
    setFormOpen(true);
  };

  const handleExcluir = async (colonia: any) => {
    if (!window.confirm(`Remover a colônia "${colonia.nome}"?`)) return;
    await api.delete(`/pesca/colonias/${colonia.uid_pesca_colonia}`);
    fetchColonias(search);
  };

  const handleSalvo = () => {
    setFormOpen(false);
    fetchColonias(search);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>Colônias de Pescadores</h1>

        <div style={{ position: 'relative', flex: 1, maxWidth: '400px', margin: '0 20px' }}>
          <Search style={{ position: 'absolute', left: '10px', top: '10px', color: '#888' }} />
          <input
            type="text"
            placeholder="Pesquisar colônia..."
            value={tempSearch}
            onChange={(e) => setTempSearch(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 10px 10px 40px',
              borderRadius: '20px',
              border: '1px solid #ddd',
              outline: 'none'
            }}
          />
        </div>

        <div className={styles.actionsHeader}>
          <p style={{ alignSelf: 'center', fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>
            Qtd: <span style={{ fontWeight: 'bold', color: 'var(--green-700)' }}>{colonias.length}</span>
          </p>

          <button className={styles.blueBtn} onClick={handleNovo} title="Adicionar Nova">
            <Add />
          </button>
          <button className={styles.blueBtn} onClick={() => window.history.back()} title="Voltar">
            <ArrowBack />
          </button>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nome da Colônia</th>
              <th>Código</th>
              <th>Município / UF</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {colonias.map((c) => (
              <tr key={c.uid_pesca_colonia}>
                <td>{c.nome}</td>
                <td>{c.codigo || '-'}</td>
                <td>{c.municipio ? `${c.municipio}${c.uf ? ' / ' + c.uf : ''}` : '-'}</td>
                <td>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    <Edit fontSize="small" style={{ color: '#03c9fe', cursor: 'pointer' }} onClick={() => handleEditar(c)} />
                    <Delete fontSize="small" style={{ color: '#f75a68', cursor: 'pointer' }} onClick={() => handleExcluir(c)} />
                  </div>
                </td>
              </tr>
            ))}
            {colonias.length === 0 && (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  Nenhuma colônia cadastrada.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {formOpen && (
        <ColoniaForm
          colonia={coloniaEditando}
          onClose={() => setFormOpen(false)}
          onSaved={handleSalvo}
        />
      )}
    </div>
  );
};

export default ColoniasList;
